import formatValues from '@1c/utils/lib/formatValues';

export const formToQuery = (values: any) =>{
  return formatValues(values, {
    bik: JSON.stringify,
  })
}
